import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: () => import('../pages/index'),
    },
    {
      path: '/about',
      name: 'About',
      component: () => import('../pages/about'),
    },
    {
      path: '/AboutRedLion',
      name: 'AboutRedLion',
      component: () => import('../pages/AboutRedLion.vue'),
    },
    {
      path: '/product',
      name: 'Product',
      component: () => import('../pages/product/index.vue'),
      children: [
        {
          path: 'productFirst',
          name: 'productFirst',
          component: () => import('../pages/product/components/productFirst'),
        },
        {
          path: 'productSecond',
          name: 'productSecond',
          component: () => import('../pages/product/components/productSecond'),
        },
        {
          path: 'productThird',
          name: 'productThird',
          component: () => import('../pages/product/components/productThird'),
        },
        {
          path: 'productFourth',
          name: 'productFourth',
          component: () => import('../pages/product/components/productFourth'),
        },
      ],
    },
    {
      path: '/market',
      name: 'marKet',
      component: () => import('../pages/market/index'),
      children: [
        {
          path: 'calendar',
          name: 'calendar',
          component: () => import('../component/market/calendar'),
        },
        {
          path: 'news',
          name: 'news',
          component: () => import('../component/market/news'),
        },
        
        {
          path: 'expert',
          name: 'expert',
          component: () => import('../component/market/expert'),
        },
      ],
    },
    {
      path: '/details',
      name: 'Details',
      component: () => import('../pages/detail'),
      children: [
        {
          path: 'detailFirst',
          name: 'detailFirst',
          component: () => import('../pages/detail/components/detailFirst'),
        },
        
      ],
    },
   
    
    {
      path: '/appdownload',
      name: 'Appdownload',
      component: () => import('../pages/Appdownload.vue'),
    },
    
    {
      path: '/Notice',
      name: 'Notice',
      component: () => import('../pages/Notice'),
    },
    {
      path: '/Qrcode',
      name: 'Qrcode',
      component: () => import('../component/QrCode/index.vue'),
    },
    {
      path: '/Application',
      name: 'Application',
      component: () => import('../pages/Application'),
    },
    {
      path: '/Privacy',
      name: 'Privacy',
      component: () => import('../pages/Privacy'),
    },
    {
      path: '/NoticeDetails',
      name: 'NoticeDetails',
      component: () => import('../pages/NoticeDetails'),
    },
    {
      path: '/newsDetails',
      name: 'newsDetails',
      component: () => import('../component/market/newsDetails'),
    },
    {
      path: '/expertDetails',
      name: 'expertDetails',
      component: () => import('../component/market/expertDetails'),
    },
    {
      path: '/Encyclopedia',
      name: 'Encyclopedia',
      component: () => import('../pages/encyclopedia'),
    },
    {
      path: '/marketDepth',
      name: 'marketDepth',
      component: () => import('../pages/marketDepth'),
    },
    {
      path: '/Faq',
      name: 'Faq',
      component: () => import('../pages/faq'),
    },

    {
      path: '/subject/promotion-7a/index',
      name: 'promotion-7a-pc',
      component: () => import('../pages/subject/promotion-7a/index'),
    },
    {
      path: '/subject/autumnOct/index',
      name: 'autumnOctPC',
      component: () => import('../pages/subject/autumnOct/index'),
    },
    {
      path: '/subject/czzj_6357/index',
      name: 'czzj_6357',
      component: () => import('../pages/subject/czzj_6357/index'),
    },
    {
      path: '/subject/czzj_6357/wap',
      name: 'czzj_6357_wap',
      component: () => import('../pages/subject/czzj_6357/wap'),
    },
    {
      path: '/subject/Ldx/index',
      name: 'LdxPC',
      component: () => import('../pages/subject/Ldx/index'),
    },
    {
      path: '/subject/feinong/index',
      name: 'feinongPC',
      component: () => import('../pages/subject/feinong/index'),
    },
    {
      path: '/subject/feinong/wap',
      name: 'feinongWap',
      component: () => import('../pages/subject/feinong/wap'),
    },
    {
      path: '/subject/feinongs/index',
      name: 'feinongPCs',
      component: () => import('../pages/subject/feinongs/index'),
    },
    {
      path: '/subject/feinongs/wap',
      name: 'feinongWaps',
      component: () => import('../pages/subject/feinongs/wap'),
    },
    {
      path: '/subject/newfeinong/index',
      name: 'newfeinongPC',
      component: () => import('../pages/subject/newfeinong/index'),
    },
    {
      path: '/subject/newfeinong/wap',
      name: 'newfeinongWap',
      component: () => import('../pages/subject/newfeinong/wap'),
    },
    {
      path: '/subject/Ldx/wap',
      name: 'LdxWap',
      component: () => import('../pages/subject/Ldx/wap'),
    },
    {
      path: '/subject/autumnOct/wap',
      name: 'autumnOctWap',
      component: () => import('../pages/subject/autumnOct/wap'),
    },
    {
      path: '/policy/policyWft',
      name: 'policyWft',
      component: () => import('../component/policy/policyWft'),
    },
    {
      path: '/policy/policyWft2',
      name: 'policyWft2',
      component: () => import('../component/policy/policyWft2'),
    },
    {
      path: '/policy/policyTsft',
      name: 'policyTsft',
      component: () => import('../component/policy/policyTsft'),
    },
    {
      path: '/policy/policyTsft2',
      name: 'policyTsft2',
      component: () => import('../component/policy/policyTsft2'),
    },
    {
      path: '/policy/policyTsft3',
      name: 'policyTsft3',
      component: () => import('../component/policy/policyTsft3'),
    },
    {
      path: '/policy/policyTsft4',
      name: 'policyTsft4',
      component: () => import('../component/policy/policyTsft4'),
    },
    {
      path: '/subject/worldCup/index',
      name: 'worldCupWeb',
      component: () => import('../pages/subject/worldCup/index'),
    },
    {
      path: '/subject/worldCup/wap',
      name: 'worldCupWap',
      component: () => import('../pages/subject/worldCup/wap'),
    },
    {
      path: '/subject/live/index',
      name: 'livePc',
      component: () => import('../pages/subject/live/index'),
    },
    {
      path: '/subject/live/wap',
      name: 'liveWap',
      component: () => import('../pages/subject/live/wap'),
    },
    {
      path: '/subject/classRoom/index',
      name: 'classRoom',
      component: () => import('../pages/subject/classRoom/index'),
    },
    {
      path: '/subject/classRoom/indexWap',
      name: 'classRoomWap',
      component: () => import('../pages/subject/classRoom/indexWap'),
    },
    {
      path: '/subject/newYear/index',
      name: 'newYear',
      component: () => import('../pages/subject/newYear/index'),
    },
    {
      path: '/subject/newYear/wap',
      name: 'newYearWap',
      component: () => import('../pages/subject/newYear/wap'),
    },
    {
      path: '/subject/newYear2025/index',
      name: 'newYear2025',
      component: () => import('../pages/subject/newYear2025/index'),
    },
    {
      path: '/subject/system/index',
      name: 'system',
      component: () => import('../pages/subject/system/index'),
    },
    {
      path: '/subject/system/wap',
      name: 'systemWap',
      component: () => import('../pages/subject/system/wap'),
    },
    {
      path: '/emailModal/email',
      name: 'email',
      component: () => import('../component/emailModal/email'),
    },
    {
      path: '/subject/report/index',
      name: 'reportPC',
      component: () => import('../pages/subject/report/index'),
    },
    {
      path: '/subject/report/wap',
      name: 'reportWap',
      component: () => import('../pages/subject/report/wap'),
    },
    {
      path: '/subject/newReport/index',
      name: 'newReportPC',
      component: () => import('../pages/subject/newReport/index'),
    },
    {
      path: '/subject/newReport/wap',
      name: 'newReportWap',
      component: () => import('../pages/subject/newReport/wap'),
    },
    // 2026投研报告
    {
      path: '/subject/opportunityStudy/index',
      name: 'opportunityStudyPC',
      component: () => import('../pages/subject/opportunityStudy/index'),
    },
    {
      path: '/subject/opportunityStudy/wap',
      name: 'opportunityStudyWap',
      component: () => import('../pages/subject/opportunityStudy/wap'),
    },
    {
      path: '/subject/searchReport/index',
      name: 'searchReportPC',
      component: () => import('../pages/subject/searchReport/index'),
    },
    {
      path: '/subject/searchReport/wap',
      name: 'searchReportWap',
      component: () => import('../pages/subject/searchReport/wap'),
    },
    {
      path: '/subject/tg_9654/index',
      name: 'tg_9654_PC',
      component: () => import('../pages/subject/tg_9654/index'),
    },
    {
      path: '/subject/tg_9654/wap',
      name: 'tg_9654_WAP',
      component: () => import('../pages/subject/tg_9654/wap'),
    },
    {
      path: '/Disclaimers',
      name: 'Disclaimers',
      component: () => import('../pages/Disclaimers'),
    },
    {
      path: '/subject/live2.0/index',
      name: 'live2.0Pc',
      component: () => import('../pages/subject/live2.0/index'),
    },
    {
      path: '/subject/live2.0/wap',
      name: 'live2.0Wap',
      component: () => import('../pages/subject/live2.0/wap'),
    },
    {
      path: '/subject/invest/index',
      name: 'investPc',
      component: () => import('../pages/subject/invest/index'),
    },
    {
      path: '/subject/invest/wap',
      name: 'investWap',
      component: () => import('../pages/subject/invest/wap'),
    },
    {
      path: '/subject/mayPage/index',
      name: 'mayPagePc',
      component: () => import('../pages/subject/mayPage/index'),
    },
    {
      path: '/subject/mayPage/wap',
      name: 'mayPageWap',
      component: () => import('../pages/subject/mayPage/wap'),
    },
    {
      path: '/subject/answer/index',
      name: 'answerPc',
      component: () => import('../pages/subject/answer/index'),
    },
    {
      path: '/subject/answer/wap',
      name: 'answerWap',
      component: () => import('../pages/subject/answer/wap'),
    },
    {
      path: '/subject/answer_8654/red/index',
      name: 'answer_8654_red_pc',
      component: () => import('../pages/subject/answer_8654/red/index'),
    },
    {
      path: '/subject/answer_8654/red/wap',
      name: 'answer_8654_red_wap',
      component: () => import('../pages/subject/answer_8654/red/wap'),
    },
    {
      path: '/subject/answer_8654/orange/index',
      name: 'answer_8654_orange_pc',
      component: () => import('../pages/subject/answer_8654/orange/index'),
    },
    {
      path: '/subject/answer_8654/orange/wap',
      name: 'answer_8654_orange_wap',
      component: () => import('../pages/subject/answer_8654/orange/wap'),
    },
    {
      path: '/subject/answer_8654/yellow/index',
      name: 'answer_8654_yellow_pc',
      component: () => import('../pages/subject/answer_8654/yellow/index'),
    },
    {
      path: '/subject/answer_8654/yellow/wap',
      name: 'answer_8654_yellow_wap',
      component: () => import('../pages/subject/answer_8654/yellow/wap'),
    },
    
    {
      path: '/subject/yx_1105/index',
      name: 'yx_1105',
      component: () => import('../pages/subject/yx_1105/index'),
    },
    {
      path: '/subject/yx_1105/wap',
      name: 'yx_1105_wap',
      component: () => import('../pages/subject/yx_1105/wap'),
    },
    {
      path: '/subject/august/index',
      name: 'august',
      component: () => import('../pages/subject/august/index'),
    },
    {
      path: '/subject/august/wap',
      name: 'augustWap',
      component: () => import('../pages/subject/august/wap'),
    },
    {
      path: '/subject/lsy-8901/index',
      name: 'lsy-8901',
      component: () => import('../pages/subject/lsy-8901/index'),
    },
    {
      path: '/subject/lsy-8901/wap',
      name: 'lsy-8901-wap',
      component: () => import('../pages/subject/lsy-8901/wap'),
    },
    {
      path: '/subject/newYear9911/index',
      name: 'newYear9911',
      component: () => import('../pages/subject/newYear9911/index'),
    },
    {
      path: '/subject/newYear9911/wap',
      name: 'newYear9911wap',
      component: () => import('../pages/subject/newYear9911/wap'),
    },
    {
      path: '/subject/sc_2024/index',
      name: 'sc_2024',
      component: () => import('../pages/subject/sc_2024/index'),
    },
    {
      path: '/subject/sc_2024/wap',
      name: 'sc_2024wap',
      component: () => import('../pages/subject/sc_2024/wap'),
    },
    {
      path: '/subject/authentication/index',
      name: 'authentication',
      component: () => import('../pages/subject/authentication/index'),
    },
    {
      path: '/subject/authentication/futong',
      name: 'authenticationFutong',
      component: () => import('../pages/subject/authentication/futong.vue'),
    },
    {
      path: '/subject/turntable/index',
      name: 'turntable',
      component: () => import('../pages/subject/turntable/index'),
    },
    {
      path: '/subject/turntable/wap',
      name: 'turntableWap',
      component: () => import('../pages/subject/turntable/wap'),
    },
    {
      path: '/subject/traderCompetition/index',
      name: 'traderCompetitionPc',
      component: () => import('../pages/subject/traderCompetition/index'),
    },
    {
      path: '/subject/traderCompetition/wap',
      name: 'traderCompetitionWap',
      component: () => import('../pages/subject/traderCompetition/wap'),
    },
    {
      path: '/subject/scratcher',
      name: 'scratcher',
      component: () => import('../pages/subject/scratcher/index'),
    },
    {
      path: '/subject/registerSuccess',
      name: 'scratcher',
      component: () => import('../pages/subject/registerSuccess/index'),
    },
    {
      path: '/subject/regression/index',
      name: 'regressionPc',
      component: () => import('../pages/subject/regression/index'),
    },
    {
      path: '/subject/regression/wap',
      name: 'regressionWap',
      component: () => import('../pages/subject/regression/wap'),
    },
    {
      path: '/subject/careFree/index',
      name: 'careFreePc',
      component: () => import('../pages/subject/careFree/index.vue'),
    },
    {
      path: '/subject/careFreeDetail/index',
      name: 'careFreePc',
      component: () => import('../pages/subject/careFreeDetail/index.vue'),
    },
    {
      path: '/subject/careFreeDetails/index',
      name: 'careFreePc',
      component: () => import('../pages/subject/careFreeDetails/index.vue'),
    },
    {
      path: '/subject/classRoom/printout',
      name: 'printOut',
      component: () => import('../pages/subject/classRoom/components/wap/printOut.vue'),
    },
    {
      path: '/subject/classRoom/myprint',
      name: 'myPrint',
      component: () => import('../pages/subject/classRoom/components/wap/myPrint.vue'),
    },
    {
      path: '/subject/classRoom/gifthistory',
      name: 'giftHistory',
      component: () => import('../pages/subject/classRoom/components/wap/giftHistory.vue'),
    },
    {
      path: '/subject/toInterGral/index',
      name: 'toInterGral',
      component: () => import('../pages/subject/toInterGral/index.vue'),
    },
    {
      path: '/subject/frendbonst',
      name: 'frendBonst',
      component: () => import('../pages/subject/frendbonst/index.vue'),
    },
    {
      path: '/subject/frendfunction',
      name: 'frendFunction',
      component: () => import('../pages/subject/frendbonst/function.vue'),
    },
    {
      path: '/subject/welfareService',
      name: 'welfareService',
      component: () => import('../pages/subject/welfareService'),
    },
    {
      path: '/subject/welfareServiceurl',
      name: 'welfareServiceurl',
      component: () => import('../pages/subject/welfareServiceurl/index.vue'),
    },
    {
      path: '/subject/Walletdistribution',
      name: 'Walletdistribution',
      component: () => import('../pages/subject/Walletdistribution/index.vue'),
    },
    // subject / anniversaryCelebration
    {
      path: '/subject/anniversaryCelebration',
      name: 'anniversaryCelebration',
      component: () => import('../pages/subject/anniversaryCelebration/index.vue'),
    },
    // {
    //   path: '/subject/transctionGrantee',
    //   name: 'transctionGrantee',
    //   component: () => import('../pages/subject/transctionGrantee/index.vue'),
    // },
    // {
    //   path: '/subject/transctionGranteewap',
    //   name: 'transctionGranteeWap',
    //   component: () => import('../pages/subject/transctionGrantee/wap.vue'),
    // },
    // {
    //   path: '/subject/transctionGranteeDw',
    //   name: 'transctionGranteeDw',
    //   component: () => import('../pages/subject/transctionGranteeDw/index.vue'),
    // },
    // {
    //   path: '/subject/transctionGranteeDwwap',
    //   name: 'transctionGranteeDwWap',
    //   component: () => import('../pages/subject/transctionGranteeDw/wap.vue'),
    // }

    
  ],
});
